import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "save-and-continue-later"
}
const _hoisted_2 = ["cancel-text", "confirm-text"]
const _hoisted_3 = { slot: "dialog-header" }
const _hoisted_4 = { slot: "dialog-body" }
const _hoisted_5 = {
  dialog: "save-and-continue-later-dialog",
  "data-testid": "save-and-continue-later-dialog-cta-trigger"
}
const _hoisted_6 = { variant: "ghost" }

import {CreationStepName, ProfileCreationStepGroup} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
    import {useTranslation} from '@malt/vue3-use';
    import {computed, inject} from 'vue';
    import {useRoute} from 'vue-router';
    import {useStore} from 'vuex';
    import {RegisteredDependencies} from '../../DependencyInjection';
    import {pushVJoySnackbar} from '@maltjoy/core-vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SaveAndContinueLater',
  setup(__props) {

    const authenticationRepository = inject(RegisteredDependencies.injectionKeys.authenticationRepository)!;

    const route = useRoute();
    const store = useStore();
    const {msg} = useTranslation();

    const isMaltStrategy = computed(() => store.state.isFunnelStrategy);

    const showSaveAndContinueLater = computed(() => {
        if (isMaltStrategy.value === true) {
            if (route.meta.stepGroup === ProfileCreationStepGroup.COMPLETION) {
                const routesWithSaveAndContinueLater = [
                    CreationStepName.COMPLETION_LINKEDIN,
                    CreationStepName.COMPLETION_EXPERIENCE,
                    CreationStepName.COMPLETION_EDUCATION,
                    CreationStepName.COMPLETION_DESCRIPTION,
                    CreationStepName.COMPLETION_PRIVACY,
                ];
                if (route.name && routesWithSaveAndContinueLater.includes(route.name as CreationStepName)) {
                    return true;
                }
            }
        }

        return false;
    });

    function closeDialogAndDisplayNotification() {
        pushVJoySnackbar({
            props: {
                message: msg('profile.creation.completion.wizard.saveandcontinue.notification.saved'),
            },
        });
    }
    async function handleCancelSaveAndContinueLater() {
        closeDialogAndDisplayNotification();
    }
    function handleConfirmSaveAndContinueLater() {
        closeDialogAndDisplayNotification();

        setTimeout(async () => {
            await authenticationRepository?.logout();
            window.location.href = '/';
        }, 1500);
    }

return (_ctx: any,_cache: any) => {
  return (showSaveAndContinueLater.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          _createElementVNode("joy-dialog", {
            id: "save-and-continue-later-dialog",
            "data-testid": "save-and-continue-later-dialog",
            "pattern-confirm": "",
            "cancel-text": _unref(msg)('profile.creation.completion.wizard.saveandcontinue.dialog.cta.cancel'),
            "confirm-text": _unref(msg)('profile.creation.completion.wizard.saveandcontinue.dialog.cta.confirm'),
            onJoyCancelDialog: handleCancelSaveAndContinueLater,
            onJoyConfirmDialog: handleConfirmSaveAndContinueLater
          }, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.saveandcontinue.dialog.title')), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.saveandcontinue.dialog.body')), 1)
          ], 40, _hoisted_2)
        ])),
        _createElementVNode("joy-dialog-trigger", _hoisted_5, [
          _createElementVNode("joy-button", _hoisted_6, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.saveandcontinue.cta.save')), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})